import { styled } from '@linaria/react'

export const Wrapper = styled.div`
  background-color: ${props => props.bgColor || 'var(--white)'};
  box-shadow: 0px 3px 16px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;

  .dhsv-button,
  .btn {
    color: var(--white);
    font-size: var(--font-size-subline);
    min-width: auto;
    width: 100%;
    margin-top: auto;
    margin-bottom 0;
  }
`

export const Image = styled.div`
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.3rem;
  position: relative;

  img {
    max-width: 100%;
    border-radius: 4px;
  }
`

export const Title = styled.p`
  font-size: var(--font-size-subline);
  line-height: var(--line-height-subline);
  font-weight: var(--font-weight-bold);
  color: var(--primary);
  margin-bottom: 1.5rem;
`

export const PlayBtn = styled.a`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
  border-style: solid;
  border-color: transparent;
  border-width: 20px 0 20px 36px;
  border-left-color: var(--white);
  transition: 0.3s ease;

  &:hover {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.1);
    box-shadow: 0 3px 16px rgba(0, 0, 0, 0.25);
  }
`
export const Badge = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  font-size: 13px;
  line-height: 1.4;
  font-weight: 600;
  color: var(--white);
  background-color: var(--primary);
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.25);
  width: 100px;
  text-align: center;
  padding: 4px;
  transform: rotate(45deg) translate(25%, -10px);
`
